import ResizeWrapper from './ResizeWrapper.vue';

export default ResizeWrapper;
